<template>
  <div class="container">
    <div class="section-title" style="text-align: center; margin-top:40px;">
      Kursy online
    </div>
    <div class="offer-container">
      <!-- <path-navigation :paths="[{ name: 'Kursy online', to: '/warsztaty' }]" /> -->
      <section class="offer-description">
        <h2>Oferta kursów online</h2>
        <p>
          Udział w zajęciach online jest niezwykle prosty i praktycznie zawsze
          dostępny. Na praktykę można połączyć się z każdego miejsca.
          Oszczędzasz w ten sposób czas na dojazdach oraz masz pewność, że
          zajęcia jogi nie będą kolidować z Twoimi planami i życiem codziennym.
          Upewniam się, że Twoja praktyka jest bezpieczna i maksymalnie
          efektywna
        </p>
      </section>
    </div>

    <div class="flex justify-center text-center" id="workshops-select">
      <template>
        <div
          v-if="availableWorkshops.length > 1"
          class="flex justify-center workshops-select mt-10"
        >
          <div
            :class="
              selectedWorkshopView.id === workshop.id ? 'selectedWorkshops' : ''
            "
            v-for="(workshop, index) in availableWorkshops"
            :key="workshop.id"
          >
            <WorkshopOffer
              :name="workshop.name"
              :listOfLi="
                workshop.time_packages_titles_elements.map((e) => e.text)
              "
              @selected="selectWorkshopView(workshop, index)"
            >
              <template #image v-if="index % 2 !== 0">
                <img src="../assets/workshops_2.png" alt="" loading="lazy" />
              </template>
              <template v-else #image>
                <img src="../assets/workshops_2.1.jpeg" alt="" loading="lazy" />
              </template>
            </WorkshopOffer>
          </div>
        </div>

        <div
          class="under-title"
          id="buy-workshops-button"
          v-if="
            loggedIn &&
              (!userWorkshops ||
                userWorkshops.filter(
                  (workshops) =>
                    workshops.workshop.id === selectedWorkshopView.id
                ).length === 0) &&
              showSlots
          "
          :class="loggedIn ? 'mb-12' : ''"
          style="color:#8B857D;"
        >
          Nie zapisałeś się jeszcze na kurs. <br />
          <div
            class=" mb-10"
            style="display: flex; align-items: center; justify-content: center;"
          >
            <a :href="selectedWorkshopView.link" class="redirect-to-payment">
              <div
                class=" primary-button"
                v-if="availableWorkshops && availableWorkshops.length > 0"
              >
                Dokonaj zakupu
              </div>
            </a>
          </div>
          <p
            class="free-slots"
            v-if="
              availableWorkshops &&
                showSlots &&
                availableWorkshops.length > 0 &&
                selectedWorkshopView.maxNumberOfMembers -
                  selectedWorkshopView.numberOfMembers <=
                  5
            "
          >
            {{
              checkSpelling(
                selectedWorkshopView.maxNumberOfMembers -
                  selectedWorkshopView.numberOfMembers
              )
            }}
          </p>
        </div>
        <div
          class="under-title"
          v-if="!loggedIn && !hasUserActiveWorkshops"
          id="buy-workshops-button"
          style="color:#6D6963"
        >
          Dostęp do warsztatów jest możliwy jedynie dla zalogowanych
          użytkowników.

          <div
            class=""
            style="display: flex; align-items: center; justify-content: center;"
          >
            <div class=" primary-button" @click="redirectLogin(0)">
              Zaloguj się
            </div>
          </div>

          <br />
        </div>

        <div>
          <DescriptionCard
            v-if="showSlots"
            :withoutBorder="true"
            :withoutTopMargin="true"
          >
            <template slot="content">
              <div
                class="workshops"
                v-if="hasUserActiveWorkshops"
                id="workshops-content"
              >
                <WorkshopItem
                  :workshop="selectedWorkshop"
                  :workshopItem="workshopItem"
                  v-for="workshopItem in this.selectedWorkshopsItems"
                  :key="workshopItem.id"
                >
                </WorkshopItem>
              </div>

              <template>
                <div>
                  <div class="description-container mt-0">
                    <div v-html="selectedWorkshopView.descriptionOne"></div>
                    <div>
                      <img
                        v-if="!selectedWorkshopView.descriptionImagesSetNumber"
                        class="workshops-image"
                        src="../assets/workshops_2.png"
                        alt="
                      praktyka dla początkujących,
                      joga stanie na rękach,
                      joga,
                      praktyka wzmacniająca,
                      szkoła online,
                      praktyka,
                      prana vyavama,
                      subskrypcja DagaJoga
                      ćwiczenia online,
                      pranajama oddech,
                      joga zdrowy
                      "
                        loading="lazy"
                      />
                      <img
                        v-if="
                          selectedWorkshopView.descriptionImagesSetNumber &&
                            selectedWorkshopView.descriptionImagesSetNumber ===
                              1
                        "
                        class="workshops-image"
                        src="../assets/workshops_2.1.jpeg"
                        alt="
                      praktyka dla początkujących,
                      joga stanie na rękach,
                      joga,
                      praktyka wzmacniająca,
                      szkoła online,
                      praktyka,
                      prana vyavama,
                      subskrypcja DagaJoga
                      ćwiczenia online,
                      pranajama oddech,
                      joga zdrowy
                      "
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <br />
                  <div class="description-container">
                    <div class="description-container-order">
                      <img
                        v-if="!selectedWorkshopView.descriptionImagesSetNumber"
                        class="workshops-image"
                        src="../assets/workshops_1.png"
                        alt="
                      praktyka dla początkujących,
                      joga stanie na rękach,
                      joga,
                      praktyka wzmacniająca,
                      szkoła online,
                      praktyka,
                      prana vyavama,
                      subskrypcja DagaJoga
                      ćwiczenia online,
                      pranajama oddech,
                      joga zdrowy
                      "
                        loading="lazy"
                      />
                      <img
                        v-if="
                          selectedWorkshopView.descriptionImagesSetNumber &&
                            selectedWorkshopView.descriptionImagesSetNumber ===
                              1
                        "
                        class="workshops-image"
                        src="../assets/workshops_2.2.jpeg"
                        alt="
                      praktyka dla początkujących,
                      joga stanie na rękach,
                      joga,
                      praktyka wzmacniająca,
                      szkoła online,
                      praktyka,
                      prana vyavama,
                      subskrypcja DagaJoga
                      ćwiczenia online,
                      pranajama oddech,
                      joga zdrowy
                      "
                        loading="lazy"
                      />
                    </div>
                    <div v-html="selectedWorkshopView.descriptionTwo"></div>
                  </div>
                  <div class="description-container">
                    <div class="start-date">
                      <div
                        class="start-date-text"
                        v-html="selectedWorkshopView.descriptionThree"
                      ></div>
                    </div>
                    <div>
                      <img
                        v-if="!selectedWorkshopView.descriptionImagesSetNumber"
                        class="workshops-image"
                        src="../assets/workshops_4.png"
                        alt="
                      praktyka dla początkujących,
                      joga stanie na rękach,
                      joga,
                      praktyka wzmacniająca,
                      szkoła online,
                      praktyka,
                      prana vyavama,
                      subskrypcja DagaJoga
                      ćwiczenia online,
                      pranajama oddech,
                      joga zdrowy
                      "
                        loading="lazy"
                      />
                      <img
                        v-if="
                          selectedWorkshopView.descriptionImagesSetNumber &&
                            selectedWorkshopView.descriptionImagesSetNumber ===
                              1
                        "
                        class="workshops-image"
                        src="../assets/workshops_2.3.jpeg"
                        alt="
                      praktyka dla początkujących,
                      joga stanie na rękach,
                      joga,
                      praktyka wzmacniająca,
                      szkoła online,
                      praktyka,
                      prana vyavama,
                      subskrypcja DagaJoga
                      ćwiczenia online,
                      pranajama oddech,
                      joga zdrowy
                      "
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div
                    class="description-container"
                    v-if="
                      availableWorkshops &&
                        availableWorkshops.length > 0 &&
                        loggedIn &&
                        (!userWorkshops ||
                          userWorkshops.filter(
                            (workshops) =>
                              workshops.workshop.id === selectedWorkshopView.id
                          ).length === 0) &&
                        showSlots
                    "
                  >
                    <div class="description-container-order">
                      <img
                        class="workshops-image workshops-image-order"
                        src="../assets/workshops_3.png"
                        alt="
                      praktyka dla początkujących,
                      joga stanie na rękach,
                      joga,
                      praktyka wzmacniająca,
                      szkoła online,
                      praktyka,
                      prana vyavama,
                      subskrypcja DagaJoga
                      ćwiczenia online,
                      pranajama oddech,
                      joga zdrowy
                      "
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <div v-html="selectedWorkshopView.descriptionFour"></div>
                      <a
                        :href="selectedWorkshopView.link"
                        class="redirect-to-payment float-left"
                      >
                        <div class=" primary-button">
                          Dokonaj zakupu
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </DescriptionCard>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import WorkshopItem from "../components/WorkshopItem.vue";
import moment from "moment";
import DescriptionCard from "../components/DescriptionCard.vue";
import WorkshopOffer from "../components/WorkshopOffer.vue";
import router from "../router";

export default {
  metaInfo: {
    title: "Dagajoga warsztaty - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej.\nPraktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
      {
        property: "og:image",
        content: "https://dagajoga.pl/wp-content/uploads/2022/02/image-5.png",
      },
    ],
  },
  name: "Workshops",
  data: () => ({
    loggedIn: false,
    hasUserActiveWorkshops: false,
    selectedWorkshop: "",
    workshopsStartDate: null,
    selectedWorkshopView: "",
    showSlots: false,
    selectedWorkshopsItems: [],
    isMobile: false,
  }),
  components: {
    WorkshopItem,
    DescriptionCard,
    WorkshopOffer,
  },
  props: {
    path: String,
  },

  async mounted() {
    const isMobile = this.checkIsMobile();
    if (isMobile) {
      this.isMobile = true;
    }
    const alreadySelectedWorkshopsId = window.localStorage.getItem(
      "selected-workshops-id"
    );
    await this.$store.dispatch("timePackages/fetchWorkshopsItems");
    const token = window.localStorage.getItem("userToken");
    if (token) {
      this.loggedIn = true;
    }
    await this.$store.dispatch("workshops/fetchAvaiableWorkshops");
    //15.03.2022
    if (this.availableWorkshops.length === 1) {
      this.selectedWorkshopView = this.availableWorkshops[0];
      this.showSlots = true;
    } else {
      if (alreadySelectedWorkshopsId) {
        this.showSlots = true;
        const selectedWorkshops = this.availableWorkshops.filter(
          (workshops) => workshops.id == alreadySelectedWorkshopsId
        );
        if (selectedWorkshops && selectedWorkshops.length > 0) {
          this.selectedWorkshopView = selectedWorkshops[0];
        }
      }
    }

    await this.loadWorkshops();

    const metaImage = document.getElementById("meta-image");
    metaImage.content =
      "https://dagajoga.pl/wp-content/uploads/2022/02/image-5.png";

    if (router.currentRoute.params.selectedWorkshopViewId) {
      const workshopToSelect = this.availableWorkshops.find(
        (aw) => aw.id === router.currentRoute.params.selectedWorkshopViewId
      );
      if (workshopToSelect) {
        this.selectWorkshopView(workshopToSelect);
      }
    } else {
      const workshopsSelectElement = document.querySelector(
        "#workshops-select"
      );
      if (workshopsSelectElement) {
        workshopsSelectElement.scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
      }
    }
  },

  watch: {
    selectedWorkshopView() {
      window.localStorage.removeItem("selected-workshops-id");
      const filteredByWorkshops = this.userWorkshops.filter(
        (workshops) => workshops.workshop.id === this.selectedWorkshopView.id
      );
      if (filteredByWorkshops[0]) {
        this.selectedWorkshopsItems = filteredByWorkshops[0].workshopItems;
      } else {
        this.selectedWorkshopsItems = [];
      }

      this.showSlots = true;
    },
  },
  computed: {
    userWorkshops() {
      return this.$store.getters["workshops/getUserWorkshops"];
    },
    availableWorkshops() {
      return this.$store.getters["workshops/getAvailableWorkshops"].filter(
        (workshops) => !workshops.hidden
      );
    },
    workshopsItems() {
      return this.$store.getters["timePackages/getWorkshopsItems"];
    },
  },
  methods: {
    checkIsMobile() {
      return (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
        navigator.userAgent.match(/Opera Mini/i) ||
        navigator.userAgent.match(/IEMobile/i) ||
        navigator.userAgent.match(/WPDesktop/i)
      );
    },
    checkSpelling(number) {
      if (number === 1) return " Zostało jedynie 1 wolne miejsce!";
      if (number === 2 || number === 3 || number === 4)
        return `Zostały jedynie ${number} wolne miejsca!`;
      else return `Zostało jedynie ${number} wolnych miejsc!`;
    },
    async loadWorkshops() {
      await this.$store.dispatch(`workshops/fetchUserWorkshops`);
      if (this.userWorkshops && this.userWorkshops.length !== 0) {
        this.hasUserActiveWorkshops = true;
        if (this.userWorkshops.length < 2) {
          this.selectedWorkshop = this.userWorkshops[0];
        }
      }
    },
    selectWorkshop(workshop) {
      this.selectedWorkshop = workshop;
    },
    async selectWorkshopView(workshop) {
      this.selectedWorkshopView = workshop;
      this.showSlots = true;

      setTimeout(() => {
        let descriptionElements = null;
        const buyButtonElement = document.querySelector(
          "#buy-workshops-button"
        );
        if (!buyButtonElement) {
          descriptionElements = document.querySelector(".workshop-item-name");
        }
        if (buyButtonElement) {
          buyButtonElement.scrollIntoView({
            block: this.isMobile ? "start" : "center",
            behavior: "smooth",
          });
        } else if (descriptionElements) {
          descriptionElements.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
        }
      }, 100);
    },
    redirectLogin(signup) {
      this.$router.push({
        name: "Auth",
        params: {
          previousPage: "Workshops",
          signup: signup,
          selectedWorkshopViewId: this.selectedWorkshopView.id,
        },
      });
    },
    getExpirationDate(date) {
      return moment(date)
        .locale("pl")
        .format("DD MMMM YYYY");
    },
    workshopsFinished(expirationDate) {
      const now = moment();
      const expirationTime = moment(expirationDate);
      if (expirationTime.isBefore(now)) {
        return true;
      } else {
        return false;
      }
    },
    redirect() {
      this.$router.push({
        name: "TimeSubscriptions",
        params: { name: "Courses" },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 2560px;
  margin: 0;
}

.offer-container {
  @media (max-width: 1024px) {
    padding-left: 3.5%;
  }
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
  h2 {
    font-size: 2.4rem;
    padding-bottom: 1.5rem;
    @media (max-width: 768px) {
      font-size: 2.1rem;
    }
    @media (max-width: 425px) {
      font-size: 1.7rem;
      text-align: center;
      padding-bottom: 1rem;
    }
  }
  p {
    color: #000;
  }
  .path {
    a {
      color: #000;
      text-decoration: none;
      font-weight: 500;
    }
    @media (max-width: 425px) {
      margin-top: -2rem;
      padding-bottom: 20px !important;
    }
  }

  .offer-description {
    background: #d9d9d9;
    border-radius: 32px;
    margin: 0 20px;
    padding: 30px;
    color: #8b857d;
    p {
      font-size: 1.05rem;
      width: 85%;
      color: #8b857d;

      @media (max-width: 425px) {
        font-size: 0.95rem;
        width: 100%;
        text-align: justify;
      }
    }
  }

  .box-container {
    display: flex;
    justify-content: center;
    margin-right: 7%;
    margin-bottom: 5rem;

    @media (max-width: 1024px) {
      margin-right: 0%;
    }

    @media (max-width: 425px) {
      flex-wrap: wrap;
    }
    .box {
      @media (max-width: 425px) {
        margin-bottom: 3rem;
      }
    }
  }
}

.action-button {
  max-width: 600px !important;
  box-shadow: none;
  color: #fff;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  border-radius: 10px;
  padding: 0.6rem 2rem;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 300;
  height: auto;
  letter-spacing: 1px;
  text-transform: none;
  margin: auto;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.free-slots {
  margin: 0 auto;
  text-align: center;
  color: #ce4257;
  margin-bottom: 1rem;
  font-weight: 500;
}
.redirect-to-payment .redirect-to-payment:visited {
  color: #fff !important;
}
.font-weight-bold {
  font-size: 22px;
}
.normal-size {
  font-size: 18px;
}
.description-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 4em 0;
  justify-content: center;
  color: #6d6963;
}
.description-container div {
  width: 50%;
  min-width: 300px;
}
.description-container div img {
  border-radius: 20px;
}
.workshops-image {
  width: 300px;
}
.select-item {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 1.5rem;
  margin-top: 10px;
  margin: 1rem;
  background-image: linear-gradient(
    319deg,
    rgba(189, 153, 153, 1) 0%,
    rgba(227, 204, 204, 1) 100%
  );
  font-size: 18px;
  line-height: 1.45;
  font-weight: 600;
  letter-spacing: 3px;
  background-position: center center;
  box-shadow: 0px 20px 40px 0px rgb(189 153 155 / 70%);
  cursor: pointer;
  min-width: 320px;
}
.selectedWorkshops {
  background: #d9d9d9;
  border-radius: 32px;
}
.workshops-select {
  font-size: 18px;
  margin-bottom: 4rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: fit-content;
  padding: 0;
  color: #fff;
}
.login-button {
  max-width: 500px;
  margin: 0 auto;
}
.redirect-to-subscriptions {
  color: #000;
  text-decoration: underline;
  font-size: 15px;
  font-weight: 500;
}
a {
  text-decoration: none;
}

/* ADDITIONAL DESCRIPTION*/
.card-desc {
  width: 70vw;
  margin-top: 5rem;
  margin-bottom: 100px;
  padding: 40px 70px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: block;
  text-align: center;
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}
.title-one {
  font-size: 54px;
  font-weight: 700;
}
.under-title {
  font-size: 20px;
  font-weight: 500;
}
p {
  text-align: left;
  font-weight: 300;
}
.title-two {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 3rem;
  position: relative;
}
.title-two::after {
  content: "";
  width: 8px;
  height: 8px;
  background: -webkit-linear-gradient(
    90deg,
    rgb(179, 106, 103) 0%,
    rgba(223, 44, 38, 1) 100%
  );
  position: absolute;
  border-radius: 30px;
  top: 35%;
  right: 100%;
  margin: 0 10px;
}
.btn-courses {
  width: fit-content;
}
.atag {
  display: flex;
  align-items: center;
  justify-content: center;
}
.list-of-courses {
  margin-bottom: 50px;
}
.login-btn {
  font-size: 1rem;
}
.position {
  position: absolute;
  padding: 30px;
  top: 0;
  right: 0;
  cursor: pointer;
  color: #1d1616d8;
}

.with-border {
  border-width: 2px;
  border-radius: 8px;
  border-color: #aebebc;
  border-style: solid;
  padding: 2rem;
}
.start-date {
  display: flex;
}
.start-date-img {
  width: 35%;
}
.workshops {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media screen and (max-width: 1050px) {
  .card-desc {
    width: 80vw;
  }
  .workshops-select {
    font-size: 16px;
    margin-bottom: 4rem;
  }
}
@media screen and (max-width: 950px) {
  .card-desc {
    width: 90vw;
  }
  .workshops-select {
    font-size: 14px;
    margin-bottom: 4rem;
  }
}
@media screen and (max-width: 820px) {
  .title-one {
    font-size: 44px;
  }
  .under-title {
    font-size: 18px;
  }
}

@media screen and (max-width: 500px) {
  .header img {
    height: 300px;
    width: fit-content;
    object-fit: cover;
  }
  .workshops-select {
    font-size: 12px;
    margin-bottom: 4rem;
  }
  .card-desc {
    width: 100vw;
    padding: 40px 30px;
  }
  .under-title {
    font-size: 15px;
  }
  p {
    font-size: 0.9rem;
  }
  .title-two {
    font-size: 1.1rem;
  }
  .title-one {
    font-size: 36px;
    display: block;
    display: -webkit-box;
  }
}
@media (max-width: 825px) {
  .description-container-order {
    flex: 0 0 100%;
    order: 2;
  }
  .description-container {
    margin: 0;
  }
  .start-date {
    flex-direction: column;
  }
  .start-date-img {
    width: 30%;
  }
}
</style>
